"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputCreateDropDownValidations = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_dropdown_behavior_1 = require("../bc-dropdown/bc-dropdown-behavior");
var bc_input_create_constants_1 = require("./bc-input-create-constants");
var BcInputCreateDropDownValidations = (function () {
    function BcInputCreateDropDownValidations() {
    }
    BcInputCreateDropDownValidations.prototype.initDropDownBehavior = function (inputCreateElement) {
        var element = inputCreateElement.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        if (element !== null) {
            var config = {
                isPopUp: true,
                parentWidth: true
            };
            this.dropDownBehavior = new bc_dropdown_behavior_1.BcDropdownBehavior();
            this.dropDownBehavior.setElement(element);
            this.dropDownBehavior.setConfig(config);
            this.dropDownBehavior.setUp();
        }
    };
    BcInputCreateDropDownValidations.prototype.createDropdownContainer = function (title, supportText, titleIconAtr) {
        var contentConditionalsHeader = this.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER);
        var contentConditionalsHeaderIcon = this.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_ICON);
        var contentConditionalsHeaderText = this.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_TEXT);
        this.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY);
        var contentConditionalsFooter = this.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_FOOTER);
        var emIcon = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        emIcon.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        emIcon.classList.add(common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        emIcon.setAttribute('aria-hidden', 'true');
        emIcon.innerText = titleIconAtr;
        contentConditionalsHeaderText.textContent = title;
        contentConditionalsFooter.textContent = supportText;
        contentConditionalsHeaderIcon.appendChild(emIcon);
        contentConditionalsHeader.appendChild(contentConditionalsHeaderIcon);
        contentConditionalsHeader.appendChild(contentConditionalsHeaderText);
    };
    BcInputCreateDropDownValidations.prototype.createContainner = function (query, classContainer) {
        var element = document.querySelector(".".concat(query));
        var section = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        section.classList.add(classContainer);
        element === null || element === void 0 ? void 0 : element.appendChild(section);
        return section;
    };
    BcInputCreateDropDownValidations.prototype.getValidations = function (conditionalItems) {
        return conditionalItems.every(function (item) { return item.state === true; });
    };
    BcInputCreateDropDownValidations.prototype.getFilterValidations = function (conditionalItems) {
        return conditionalItems.filter(function (item) { return item.state === false; });
    };
    BcInputCreateDropDownValidations.prototype.changeStatusItem = function (id, inputCreateElement) {
        var contentConditionals = inputCreateElement.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS));
        var item = contentConditionals.querySelector("#".concat(bc_input_create_constants_1.BcInputCreateConstants.ID_CONDITION_TEXT, "-").concat(id));
        var icon = item.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE));
        var text = item.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT));
        var em = icon.querySelector(common_constants_1.BcCommonConstants.EM_TAG);
        em.textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_ERROR;
        em.setAttribute('aria-hidden', 'false');
        em.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'No lo cumple');
        icon.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE, "-").concat(bc_input_create_constants_1.BcInputCreateConstants.ERROR_VALUE));
        text.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT, "-").concat(bc_input_create_constants_1.BcInputCreateConstants.ERROR_VALUE));
    };
    BcInputCreateDropDownValidations.prototype.changeStatusItemDot = function (id, inputCreateElement) {
        var contentConditionals = inputCreateElement.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS));
        var item = contentConditionals.querySelector("#".concat(bc_input_create_constants_1.BcInputCreateConstants.ID_CONDITION_TEXT, "-").concat(id));
        var icon = item.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE));
        var text = item.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT));
        var em = icon.querySelector(common_constants_1.BcCommonConstants.EM_TAG);
        em.textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_DOT;
        icon.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE));
        text.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT));
    };
    BcInputCreateDropDownValidations.prototype.getConditionIcon = function (id, inputCreateElement) {
        var contentDropdown = inputCreateElement.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_DROPDOWN_CONTENT_ACTIVE));
        var item = contentDropdown.querySelector("#".concat(bc_input_create_constants_1.BcInputCreateConstants.ID_CONDITION_TEXT, "-").concat(id));
        var itemText = item.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT));
        var itemContentIcon = item.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE));
        itemText.classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT, "-").concat(bc_input_create_constants_1.BcInputCreateConstants.ERROR_VALUE));
        var itemIcon = item.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_ICONS_STATE_CONDITION));
        itemContentIcon.classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE, "-").concat(bc_input_create_constants_1.BcInputCreateConstants.ERROR_VALUE));
        return [itemContentIcon, itemIcon];
    };
    BcInputCreateDropDownValidations.prototype.changeGeneralState = function (condition, value, conditionalItems) {
        conditionalItems.forEach(function (item) {
            if (item.condition === condition) {
                item.state = value;
            }
        });
    };
    BcInputCreateDropDownValidations.prototype.changeState = function (id, success, inputCreateElement, conditionalItems) {
        var returnSetItems = this.getConditionIcon(id, inputCreateElement);
        if (success === true) {
            this.changeGeneralState(id, true, conditionalItems);
            returnSetItems[0].classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE, "-").concat(bc_input_create_constants_1.BcInputCreateConstants.SUCCESS_VALUE));
            returnSetItems[1].textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_OK;
            returnSetItems[1].setAttribute('aria-hidden', 'false');
            returnSetItems[1].setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'Lo cumple');
        }
        else {
            this.changeGeneralState(id, false, conditionalItems);
            returnSetItems[0].classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE, "-").concat(bc_input_create_constants_1.BcInputCreateConstants.SUCCESS_VALUE));
            returnSetItems[1].textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_DOT;
            returnSetItems[1].setAttribute('aria-hidden', 'true');
        }
    };
    BcInputCreateDropDownValidations.prototype.changeStateByCondition = function (id, condition, inputCreateElement, conditionalItems) {
        condition ? this.changeState(id, true, inputCreateElement, conditionalItems) : this.changeState(id, false, inputCreateElement, conditionalItems);
    };
    BcInputCreateDropDownValidations.prototype.conditionMaxLenght = function (id, input, maxCharacters, minCharacters, inputCreateElement, conditionalItems) {
        if (minCharacters === undefined && maxCharacters === undefined) {
            minCharacters = bc_input_create_constants_1.BcInputCreateConstants.INPUT_CREATE_8;
        }
        if (minCharacters && maxCharacters === undefined) {
            this.changeStateByCondition(id, (input.length >= minCharacters), inputCreateElement, conditionalItems);
        }
        if (minCharacters === undefined && maxCharacters) {
            this.changeStateByCondition(id, (input.length <= maxCharacters), inputCreateElement, conditionalItems);
        }
        if (minCharacters && maxCharacters) {
            this.changeStateByCondition(id, (input.length >= minCharacters && input.length <= maxCharacters), inputCreateElement, conditionalItems);
        }
    };
    BcInputCreateDropDownValidations.prototype.conditionCapitalLetters = function (id, input, type, inputCreateElement, conditionalItems) {
        if (type == bc_input_create_constants_1.BcInputCreateConstants.TYPE_UPPERCASE) {
            this.changeStateByCondition(id, (/[A-Z]/.test(input)), inputCreateElement, conditionalItems);
        }
        if (type == bc_input_create_constants_1.BcInputCreateConstants.TYPE_LOWERCASE) {
            this.changeStateByCondition(id, (/[a-z]/.test(input)), inputCreateElement, conditionalItems);
        }
    };
    BcInputCreateDropDownValidations.prototype.conditionSomeNumbers = function (id, input, numbers, inputCreateElement, conditionalItems) {
        var inputArr = Array.from(input);
        var aux = 0;
        inputArr.forEach(function (char) {
            if (Number(char) || char === '0') {
                aux++;
            }
        });
        this.changeStateByCondition(id, (aux >= numbers), inputCreateElement, conditionalItems);
    };
    BcInputCreateDropDownValidations.prototype.conditionInitialCharacter = function (id, input, type, inputCreateElement, conditionalItems) {
        var inputArr = Array.from(input);
        if (type === bc_input_create_constants_1.BcInputCreateConstants.TYPE_CHARACTER) {
            this.changeStateByCondition(id, ((/[A-Z]/.test(inputArr[0]) || /[a-z]/.test(inputArr[0])) && input !== ''), inputCreateElement, conditionalItems);
        }
        if (type === bc_input_create_constants_1.BcInputCreateConstants.TYPE_NUMBER) {
            this.changeStateByCondition(id, ((Number(inputArr[0]) || inputArr[0] === '0') && input !== ''), inputCreateElement, conditionalItems);
        }
    };
    BcInputCreateDropDownValidations.prototype.conditionSpecialCharacter = function (id, input, condition, inputCreateElement, conditionalItems) {
        if (condition) {
            this.changeStateByCondition(id, (this.hasSpecialChars(input)), inputCreateElement, conditionalItems);
        }
        if (!condition) {
            this.changeStateByCondition(id, (!this.hasSpecialChars(input)), inputCreateElement, conditionalItems);
        }
    };
    BcInputCreateDropDownValidations.prototype.hasSpecialChars = function (input) {
        var specialChars = /[`¡!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/¿?~]/;
        return specialChars.test(input);
    };
    BcInputCreateDropDownValidations.prototype.conditionConsecutiveNumbers = function (id, input, ascAndDesc, inputCreateElement, conditionalItems, max) {
        if (max === void 0) { max = bc_input_create_constants_1.BcInputCreateConstants.NUMBER_TWO; }
        if (input.length !== 0) {
            this.changeState(id, true, inputCreateElement, conditionalItems);
        }
        this.changeStateByCondition(id, (!this.hasConsecutive(input, max, ascAndDesc)), inputCreateElement, conditionalItems);
        if (input === '') {
            this.changeState(id, false, inputCreateElement, conditionalItems);
        }
    };
    BcInputCreateDropDownValidations.prototype.conditionSpecialCharacterpipe = function (id, input, inputCreateElement, conditionalItems) {
        var charRegExp = /[|ñÑ]/;
        var doesNotContainTargetChar = !charRegExp.test(input);
        this.changeStateByCondition(id, doesNotContainTargetChar, inputCreateElement, conditionalItems);
    };
    BcInputCreateDropDownValidations.prototype.hasConsecutive = function (input, max, ascAndDesc) {
        var inputArr = Array.from(input);
        var cont = 1;
        var rta = false;
        if (input.length > 1) {
            cont = this.calculateResult(inputArr, ascAndDesc);
        }
        if (cont >= max) {
            rta = true;
        }
        return rta;
    };
    BcInputCreateDropDownValidations.prototype.calculateResult = function (inputArr, ascAndDesc) {
        var aux = 1;
        for (var index = 1; index < inputArr.length; index++) {
            var character = inputArr[index];
            var current = Number(inputArr[index]);
            var previous = Number(inputArr[index - 1]);
            if (Number(character) || character === "0") {
                aux += this.increaseAux(ascAndDesc, current, previous);
            }
        }
        return aux;
    };
    BcInputCreateDropDownValidations.prototype.increaseAux = function (ascAndDesc, current, previous) {
        var aux = 0;
        if (ascAndDesc === true) {
            if (Math.abs(current - previous) === 1) {
                aux++;
            }
        }
        else {
            if (current - previous === 1) {
                aux++;
            }
        }
        return aux;
    };
    BcInputCreateDropDownValidations.prototype.createConditionItem = function (idCondition, description, position, maxPos, inputCreateElement) {
        var contentBody = inputCreateElement.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY));
        var item = this.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY, bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM);
        item.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.ID_ATR, "".concat(bc_input_create_constants_1.BcInputCreateConstants.ID_CONDITION_TEXT, "-").concat(idCondition));
        var sectionIconState = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        var sectionTextCondition = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        var iconState = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        sectionIconState.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE);
        sectionTextCondition.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT);
        iconState.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        iconState.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_ICONS_STATE_CONDITION);
        sectionTextCondition.innerText = description;
        iconState.innerText = bc_input_create_constants_1.BcInputCreateConstants.ICON_DOT;
        sectionIconState.appendChild(iconState);
        item.appendChild(sectionIconState);
        item.appendChild(sectionTextCondition);
        contentBody.appendChild(item);
        sectionTextCondition.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(description, ". Elemento ").concat(position, " de ").concat(maxPos));
        iconState.setAttribute('aria-hidden', 'true');
    };
    BcInputCreateDropDownValidations.prototype.validateConditionals = function (inputCreateElement, conditionalItems, conditionalsAtr, typeAtr, returnValue) {
        var _this = this;
        var conditionals = JSON.parse(conditionalsAtr);
        var dropdownQuery = inputCreateElement.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        var input = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        this.addConditionalItems(conditionalsAtr, conditionalItems, inputCreateElement);
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
            var value = input.value;
            for (var condition in conditionals) {
                var parameters = conditionals[condition];
                if (condition === bc_input_create_constants_1.BcInputCreateConstants.CONDITION_SPECIAL_CHARACTERPIPE) {
                    _this.conditionSpecialCharacterpipe(condition, value, inputCreateElement, conditionalItems);
                }
                if (condition === bc_input_create_constants_1.BcInputCreateConstants.CONDITION_MAX_LENGTH) {
                    _this.conditionMaxLenght(condition, value, parameters.max, parameters.min, inputCreateElement, conditionalItems);
                }
                if (condition === bc_input_create_constants_1.BcInputCreateConstants.CONDITION_CAPITAL_LETTERS) {
                    _this.conditionCapitalLetters(condition, value, parameters.type, inputCreateElement, conditionalItems);
                }
                if (condition === bc_input_create_constants_1.BcInputCreateConstants.CONDITION_SOME_NUMBERS) {
                    _this.conditionSomeNumbers(condition, value, parameters.numbers, inputCreateElement, conditionalItems);
                }
                if (condition === bc_input_create_constants_1.BcInputCreateConstants.CONDITION_INITIAL_CHARACTERS) {
                    _this.conditionInitialCharacter(condition, value, parameters.type, inputCreateElement, conditionalItems);
                }
                if (condition === bc_input_create_constants_1.BcInputCreateConstants.CONDITION_SPECIAL_CHARACTER) {
                    _this.conditionSpecialCharacter(condition, value, parameters.condition, inputCreateElement, conditionalItems);
                }
                if (condition === bc_input_create_constants_1.BcInputCreateConstants.CONDITION_CONSECUTIVE_NUMBERS) {
                    _this.conditionConsecutiveNumbers(condition, value, parameters.ascAndDesc, inputCreateElement, conditionalItems, parameters.max);
                }
            }
            _this.asignValidations(value, conditionalItems, typeAtr, returnValue);
        });
    };
    BcInputCreateDropDownValidations.prototype.addConditionalItems = function (conditionalsAtr, conditionalItems, inputCreateElement) {
        var _this = this;
        var conditionals = JSON.parse(conditionalsAtr);
        var conditions = [bc_input_create_constants_1.BcInputCreateConstants.CONDITION_MAX_LENGTH, bc_input_create_constants_1.BcInputCreateConstants.CONDITION_SPECIAL_CHARACTERPIPE, bc_input_create_constants_1.BcInputCreateConstants.CONDITION_CAPITAL_LETTERS,
            bc_input_create_constants_1.BcInputCreateConstants.CONDITION_SOME_NUMBERS, bc_input_create_constants_1.BcInputCreateConstants.CONDITION_INITIAL_CHARACTERS,
            bc_input_create_constants_1.BcInputCreateConstants.CONDITION_SPECIAL_CHARACTER, bc_input_create_constants_1.BcInputCreateConstants.CONDITION_CONSECUTIVE_NUMBERS];
        var quantity = Object.keys(conditionals).length;
        var cont = 0;
        var _loop_1 = function (condition) {
            var parameters = conditionals[condition];
            conditions.forEach(function (conditional) {
                if (condition === conditional) {
                    cont++;
                    _this.addConditionWithState(condition, conditionalItems);
                    _this.createConditionItem(conditional, parameters.description, cont, quantity, inputCreateElement);
                }
            });
        };
        for (var condition in conditionals) {
            _loop_1(condition);
        }
    };
    BcInputCreateDropDownValidations.prototype.addConditionWithState = function (condition, conditionalItems) {
        var item = { condition: condition, state: false };
        conditionalItems.push(item);
    };
    BcInputCreateDropDownValidations.prototype.asignValidations = function (inputValidator, conditionalItems, typeAtr, returnValue) {
        var totalValidators = this.getValidations(conditionalItems);
        if (typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_USER) {
            returnValue[bc_input_create_constants_1.BcInputCreateConstants.USER_VALUE] = inputValidator;
        }
        if (typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD) {
            returnValue[bc_input_create_constants_1.BcInputCreateConstants.PASSWORD_VALUE] = inputValidator;
            returnValue[bc_input_create_constants_1.BcInputCreateConstants.VALIDATIONS_VALUE] = totalValidators;
        }
        if (typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE) {
            returnValue[bc_input_create_constants_1.BcInputCreateConstants.NEW_PASSWORD_VALUE] = inputValidator;
            returnValue[bc_input_create_constants_1.BcInputCreateConstants.VALIDATIONS_VALUE] = totalValidators;
        }
        if (typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE) {
            returnValue[bc_input_create_constants_1.BcInputCreateConstants.NEW_PASSWORD_VALUE] = inputValidator;
            returnValue[bc_input_create_constants_1.BcInputCreateConstants.VALIDATIONS_VALUE] = totalValidators;
        }
    };
    return BcInputCreateDropDownValidations;
}());
exports.BcInputCreateDropDownValidations = BcInputCreateDropDownValidations;
